import { Button } from "../button";
import { Icon } from "../icons";
import { useColorModeContext } from "./color-mode-provider";

export function ColorModeButton() {
	/** Context */
	const { toggleColorMode } = useColorModeContext();

	/** Render */
	return (
		<div className="shrink-0">
			<Button
				icon={<Icon name="Sun" />}
				onClick={toggleColorMode}
				variant="gray"
			/>
		</div>
	);
}
